import { useParams } from "react-router-dom";
import ApiStatus from "../apiStatus";
import ValidationSummary from "../ValidationSummary";
import { useFetchTerminal, useUpdateTerminal } from "../hooks/TerminalHooks";
import TerminalForm from "./TerminalForm";
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const TerminalEdit = () => {
  const { t } = useTranslation();
  const { organisationId, terminalId, unitId } = useParams<{ organisationId: string, terminalId: string, unitId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  if (!terminalId) throw Error("Need a terminal id");
  if (!unitId) throw Error("Need a unit id");
  const { data, status, isSuccess } = useFetchTerminal(organisationId, unitId, terminalId);
  const updateTerminalMutation = useUpdateTerminal(organisationId, unitId);

  if (!isSuccess) return <ApiStatus status={status} />;

  const terminalWithLocalDates = { 
    ...data,
    validFrom: new Date(data.validFrom + 'Z'),
    validTo: new Date(data.validTo + 'Z'),
    lastModified: new Date(data.lastModified + 'Z') 
  };

  return (
    <>
      {updateTerminalMutation.isError && (
        <ValidationSummary error={updateTerminalMutation.error} />
      )}
      {updateTerminalMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('terminal.addWait')}</p>
        </div>
      ) : (
        <TerminalForm
          headerText={t('terminal.edit')}
          terminal={terminalWithLocalDates}
          submitted={(terminal) => {
            updateTerminalMutation.mutate(terminal, {
              onSuccess: () => {
                toast.success(t('terminal.editSuccess'));
                history.back();
              },
              onError: () => {
                toast.error(t('terminal.editError'));
              }
            });
          }}
        />
      )}
    </>
  );
};

export default TerminalEdit;
